// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PgoLonAQFPFMNk {
  padding-bottom: 32px;
  padding-left: 32px;
}
@media only screen and (max-width: 600px) {
  .PgoLonAQFPFMNk {
    padding-top: 32px;
  }
}
.LsZ8MQr8xfTIMW {
  display: inline-block;
  margin-left: 8px;
  list-style: none;
  white-space: nowrap;
}
.LsZ8MQr8xfTIMW:first-child {
  margin-left: 0;
}
.LsZ8MQr8xfTIMW::after {
  content: '/';
  padding-left: 8px;
  color: var(--ds-text-subtle, #44546f);
}
.LsZ8MQr8xfTIMW:last-child::after {
  content: '';
  padding-left: 0;
}
.LsZ8MQr8xfTIMW a {
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.LsZ8MQr8xfTIMW a:hover {
  text-decoration: underline;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbsList": `PgoLonAQFPFMNk`,
	"breadcrumbItem": `LsZ8MQr8xfTIMW`
};
export default ___CSS_LOADER_EXPORT___;
